import Icon, { IconIdType } from "@/components/ui/Icon";
import { Typography } from "@/components/ui/typography";
import { cn } from "@/lib/utils";
import { ChevronDown } from "lucide-react";
import { memo } from "react";

type ProcessWorkCardMobileProps = {
    index: number;
    title: string;
    description: string;
    iconId: IconIdType;
    isLast?: boolean;
  } & React.ComponentProps<"div">;
  
  const ProcessWorkCardMobile = ({
    title,
    iconId,
    index,
    description,
    isLast,
    className,
  }: ProcessWorkCardMobileProps) => {
    return (
      <div
        className={cn(
          "flex last-child",
  
          className
        )}
      >
        <div className="relative shrink-0 mr-6">
          <span className="inline-flex items-center justify-center shrink-0 w-13.5 h-13.5">
            <span className="relative inline-flex items-center justify-center w-13.5 h-13.5 shrink-0 rounded-full bg-white shadow-[0_8px_16px_0_rgba(0,0,0,0.12)] z-[2]">
              <Icon
                id={iconId}
                width={32}
                height={32}
                className="w-8 h-8 text-semantic-text-primary"
              />
              <span className="w-4.5 h-4.5 leading-0 flex items-center justify-center rounded-full bg-blue text-white text-[11px] leading-[150%] text-center absolute -top-[5px] -right-[3px]">
                {index}
              </span>
            </span>
            {!isLast && (
              <span
                className="absolute top-13.5 -bottom-3.5 left-1/2 transform -translate-x-1/2 border-r border-dashed border-r-neutral-200 text-neutral-200"
                aria-hidden="true"
              >
                <ChevronDown
                  width={11}
                  height={11}
                  className="absolute -left-[5px] transform -bottom-1.5"
                />
              </span>
            )}
          </span>
        </div>
        <div className="min-w-0 flex-auto">
          <div className="grid grid-cols-1 gap-2 place-content-start flex-auto">
            <Typography variant="titleSm" asChild className="font-medium">
              <h4>{title}</h4>
            </Typography>
            {!!description && (
              <Typography
                variant="labelMd"
                asChild
                className="text-semantic-text-primary leading-[160%]"
              >
                <p>{description}</p>
              </Typography>
            )}
          </div>
        </div>
      </div>
    );
  };

export default memo(ProcessWorkCardMobile);
